import { Tokens } from '@tmov/design-system/theme/types';
import styled from 'styled-components';

export const Container = styled.div`
  color: ${Tokens.eixods.colors.brand.primary[120]};

  width: 100%;
  min-height: ${props => props.height};
  display: flex;
  justify-content: center;
  align-items: center;
`;
